export default "__VITE_ASSET__Bsn4GIPk__"